import React from 'react';

import { SelectTW } from 'components/opsVisibility/components/inventoryHistoryV2/filterComponentTailwind/SelectTW';

import { formatSelectOptions, getOptionLabel } from './selectFilterUtils';

import '../filterComponents.css';

function SelectFilterTW({
    currentValue,
    deletable,
    filterKey,
    label,
    loading = false,
    multiple = false,
    onFilterChange,
    options = [],
    placeholder = 'Select...',
    searchable = false,
    type,
}) {
    const formattedOptions = formatSelectOptions(options);

    const getValue = () => {
        if (!currentValue) return null;

        if (multiple) {
            return Array.isArray(currentValue) ? currentValue.map((v) => v.data) : [];
        }
        return currentValue.data;
    };

    const handleChange = (value) => {
        if (value === null) {
            onFilterChange(null);
            return;
        }

        if (multiple) {
            onFilterChange(
                value.map((val) => ({
                    type,
                    data: val,
                    chipLabel: `${label}: ${getOptionLabel(val, formattedOptions)}`,
                    filterKey,
                    deletable,
                })),
            );
        } else {
            onFilterChange({
                type,
                data: value,
                chipLabel: `${label}: ${getOptionLabel(value, formattedOptions)}`,
                filterKey,
                deletable,
            });
        }
    };

    return (
        <SelectTW
            options={formattedOptions}
            value={getValue()}
            onChange={handleChange}
            placeholder={placeholder}
            multiple={multiple}
            loading={loading}
            searchable={searchable}
        />
    );
}

export { SelectFilterTW };
